import {
  fetchDELETE,
  fetchGET,
  fetchPOST,
  fetchPUT,
} from "../utils/handler_http";
import { encoJSON, encoURI } from "../utils/handler_validations";

/**
 * Obtener la lista de whitelist y estado
 */
export const getWhitelist = async (jwt = "") => {
  const resp = await fetchGET(
    process.env.REACT_APP_WHITELIST_ENDPOINT,
    {},
    { Authorization: jwt },
  );
  return resp;
};

/**
 * Agregar teléfono a la whitelist
 */
export const addToWhitelist = async (tel = "", userType = "BOTH", jwt = "", feature = "APP") => {
  const paramsBody = {
    tel: tel,
    userType: encoURI(userType),
    feature: encoURI(feature),
  };
  const response = await fetchPOST(
    process.env.REACT_APP_WHITELIST_ENDPOINT,
    paramsBody,
    { Authorization: jwt },
  );
  return response;
};

/**
 * Eliminar registro de la whitelist
 */
export const removeFromWhitelist = async (id = 0, jwt = "", feature = "APP") => {
  const paramsBody = {
    id: encoJSON(id),
    feature: encoURI(feature),
  };
  const response = await fetchDELETE(
    process.env.REACT_APP_WHITELIST_ENDPOINT,
    paramsBody,
    { Authorization: jwt },
  );
  return response;
};

/**
 * Activar/desactivar modo whitelist
 */
export const toggleWhitelist = async (enabled = false, jwt = "", feature = "APP") => {
  const paramsBody = {
    enabled: encoJSON(enabled),
    feature: encoURI(feature),
  };
  const response = await fetchPUT(
    process.env.REACT_APP_WHITELIST_TOGGLE_ENDPOINT,
    paramsBody,
    { Authorization: jwt },
  );
  return response;
};
